(function () {
var COLORS = window.EC_COLORS||[];
var CMAP = {}; COLORS.forEach(function (p) { CMAP[p[0]] = p[1]; });
var TYPES_BY_COLLECTION = window.EC_TYPES||{};
var TYPES = [];
function money(t) {
if (!t) return null;
var s = ('' + t).replace(/[^0-9.,]/g, '').replace(/,/g, '');
var f = parseFloat(s);
return isNaN(f) ? null : f;
}
function ready(fn) {
if (document.readyState !== 'loading') fn();
else document.addEventListener('DOMContentLoaded', fn);
}
function build(cards, out) {
var maxP = 0;
cards.forEach(function (c) {
var te = c.querySelector('.product-grid-title, .product-title');
var title = (te ? te.textContent : c.textContent || '').toLowerCase();
var cols = [];
COLORS.forEach(function (p) { if (title.indexOf(p[0]) > -1 && cols.indexOf(p[0]) < 0) cols.push(p[0]); });
c._cols = cols;
var ty = null;
for (var ti = 0; ti < TYPES.length; ti++) { if (TYPES[ti][1].test(title)) { ty = TYPES[ti][0]; break; } }
c._type = ty;
var g = null;
var m2 = title.match(/(\d+)\s*\+\s*(\d+)\s*c/);
if (m2) g = parseInt(m2[1], 10) + parseInt(m2[2], 10);
else { var m = title.match(/(\d+)\s*(?:c\b|gavet|cajon)/); if (m) g = parseInt(m[1], 10); }
c._gav = g;
var pe = c.querySelector('.product-price');
var pr = money(pe ? pe.textContent : '');
c._price = pr; if (pr && pr > maxP) maxP = pr;
});
var colorSet = {}, gavSet = {}, typeSet = {};
cards.forEach(function (c) {
c._cols.forEach(function (k) { colorSet[k] = true; });
if (c._gav) gavSet[c._gav] = true;
if (c._type) typeSet[c._type] = (typeSet[c._type] || 0) + 1;
});
var colorKeys = COLORS.map(function (p) { return p[0]; }).filter(function (k) { return colorSet[k]; });
var gavKeys = Object.keys(gavSet).map(Number).sort(function (a, b) { return a - b; });
var typeKeys = TYPES.map(function (t) { return t[0]; }).filter(function (k, i, a) { return typeSet[k] && a.indexOf(k) === i; });
var priceCap = Math.ceil(maxP / 10) * 10 || 0;
var st = { colors: {}, gav: {}, price: priceCap, types: {} };
var aside = document.createElement('aside');
aside.className = 'ess-side';
var h = '<div class="ess-side__head">Filtros</div>';
if (typeKeys.length > 1) {
h += '<div class="ess-fg"><div class="ess-fg__t">Tipo de producto</div><div class="ess-chk">';
typeKeys.forEach(function (k) { h += '<label><input type="checkbox" data-t="' + k + '"> ' + k + ' <span class="ess-n">(' + typeSet[k] + ')</span></label>'; });
h += '</div></div>';
}
if (colorKeys.length) {
h += '<div class="ess-fg"><div class="ess-fg__t">Color</div><div class="ess-sw">';
colorKeys.forEach(function (k) {
h += '<span class="ess-c" data-c="' + k + '" title="' + k + '" style="background:' + (CMAP[k] || '#ccc') + '"></span>';
});
h += '</div></div>';
}
if (gavKeys.length > 1) {
h += '<div class="ess-fg"><div class="ess-fg__t">N&ordm; de gavetas</div><div class="ess-chk">';
gavKeys.forEach(function (g) { h += '<label><input type="checkbox" data-g="' + g + '"> ' + g + ' gavetas</label>'; });
h += '</div></div>';
}
if (priceCap) {
h += '<div class="ess-fg"><div class="ess-fg__t">Precio</div><div class="ess-price"><span>$0</span>' +
'<input type="range" min="0" max="' + priceCap + '" value="' + priceCap + '" class="ess-range">' +
'<span class="ess-pv">$' + priceCap + '</span></div></div>';
}
h += '<button type="button" class="ess-clear">&#10005; Borrar filtros</button>';
aside.innerHTML = h;
var row = document.createElement('div');
row.className = 'ess-row';
out.parentNode.insertBefore(row, out);
row.appendChild(aside);
row.appendChild(out);
var count = document.createElement('div');
count.className = 'ess-count';
out.insertBefore(count, out.firstChild);
function apply() {
var actC = Object.keys(st.colors).filter(function (k) { return st.colors[k]; });
var actG = Object.keys(st.gav).filter(function (k) { return st.gav[k]; }).map(Number);
var actT = Object.keys(st.types).filter(function (k) { return st.types[k]; });
var shown = 0;
cards.forEach(function (c) {
var ok = true;
if (actT.length && (!c._type || actT.indexOf(c._type) < 0)) ok = false;
if (ok && actC.length && !actC.some(function (k) { return c._cols.indexOf(k) > -1; })) ok = false;
if (ok && actG.length && actG.indexOf(c._gav) < 0) ok = false;
if (ok && c._price != null && c._price > st.price) ok = false;
c.style.display = ok ? '' : 'none';
if (ok) shown++;
});
count.textContent = shown + ' producto' + (shown === 1 ? '' : 's');
}
aside.addEventListener('click', function (e) {
var sw = e.target.closest ? e.target.closest('.ess-c') : null;
if (sw) { var k = sw.getAttribute('data-c'); st.colors[k] = !st.colors[k]; sw.classList.toggle('on', !!st.colors[k]); apply(); return; }
if (e.target.classList && e.target.classList.contains('ess-clear')) {
st = { colors: {}, gav: {}, price: priceCap, types: {} };
aside.querySelectorAll('.ess-c.on').forEach(function (x) { x.classList.remove('on'); });
aside.querySelectorAll('input[data-g]').forEach(function (x) { x.checked = false; });
aside.querySelectorAll('input[data-t]').forEach(function (x) { x.checked = false; });
var r = aside.querySelector('.ess-range'); if (r) { r.value = priceCap; aside.querySelector('.ess-pv').textContent = '$' + priceCap; }
apply();
}
});
aside.addEventListener('change', function (e) {
if (e.target.matches && e.target.matches('input[data-g]')) { st.gav[e.target.getAttribute('data-g')] = e.target.checked; apply(); }
if (e.target.matches && e.target.matches('input[data-t]')) { st.types[e.target.getAttribute('data-t')] = e.target.checked; apply(); }
});
var range = aside.querySelector('.ess-range');
if (range) range.addEventListener('input', function () { st.price = +range.value; aside.querySelector('.ess-pv').textContent = '$' + range.value; apply(); });
cards.forEach(function (c) {
var img = c.querySelector('.ptest');
var q = c.querySelector('.quick-view');
if (img && q) { img.appendChild(q); q.classList.add('ess-quick'); }
});
apply();
}
ready(function () {
var sb = document.getElementById('SortBy');
if (sb) {
sb.classList.add('ess-sort');
[].slice.call(sb.options).forEach(function (o) {
var v = (o.value || '').toLowerCase(), t = (o.textContent || '').toLowerCase();
if (v.indexOf('ascending') > -1 || t.indexOf('bajo') > -1 || t.indexOf('menor a mayor') > -1) o.textContent = 'Precio: de menor a mayor';
else if (v.indexOf('descending') > -1 || t.indexOf('mayor a menor') > -1) o.textContent = 'Precio: de mayor a menor';
});
}
var root = document.getElementById('collection-template');
if (!root) return;
var out = document.getElementById('productOutput');
if (!out) return;
if (out.querySelectorAll('.grid-product-container').length < 1) return;
var grid = out.querySelector('.index-pgi') || out;
var mh = location.pathname.match(/\/collections\/([^\/?#]+)/);
var handle = mh ? mh[1].toLowerCase() : '';
TYPES = TYPES_BY_COLLECTION[handle] || [];
var seen = {};
function href(c) { var a = c.querySelector('a[href]'); return a ? a.getAttribute('href').split('?')[0] : Math.random().toString(); }
[].slice.call(out.querySelectorAll('.grid-product-container')).forEach(function (c) { seen[href(c)] = true; });
var base = location.pathname;
var extra = location.search.replace(/[?&]page=\d+/g, '').replace(/^&/, '?');
function urlFor(p) { return base + (extra ? extra + '&' : '?') + 'page=' + p; }
function loadPage(p) {
return fetch(urlFor(p), { credentials: 'same-origin' })
.then(function (r) { return r.ok ? r.text() : ''; })
.then(function (html) {
if (!html) return false;
var doc = new DOMParser().parseFromString(html, 'text/html');
var o2 = doc.getElementById('productOutput');
var more = o2 ? [].slice.call(o2.querySelectorAll('.grid-product-container')) : [];
var added = 0;
more.forEach(function (c) {
var hk = href(c);
if (seen[hk]) return;
seen[hk] = true;
grid.appendChild(document.importNode(c, true));
added++;
});
return added > 0;
})
.catch(function () { return false; });
}
var ORDER = { ninos: [/\bcama|cuna|litera|\bnido/, /trofast/, /poang/] };
function orderPri(c, ord) {
var te = c.querySelector('.product-grid-title, .product-title');
var t = (te ? te.textContent : c.textContent || '').toLowerCase();
for (var i = 0; i < ord.length; i++) { if (ord[i].test(t)) return i; }
return ord.length;
}
var BANISH = { comedor: ['forsegla-posavaso-4-bambu'], oficina: ['navlinge-lampara-blanca-de-mesa', 'ranarp-lampara-de-mesa-de-trabajo-blanca', 'svallet-lampara-de-mesa', 'navlinge-lampara-negra-de-mesa', 'tertial-lampara-gris-oscuro', 'navlinge-lampara-clip-negra', 'ranarp-lampara-de-mesa-de-trabajo-negra', 'tertial-lampara-turquesa', 'rodflik-lampara-de-mesa-verde-grisaceo', 'rodflik-lampara-de-mesa-crema', 'isnalen-lampara-led-blanca-dorada', 'skurup-lampara-de-mesa', 'skurup-lampara-de-clip-negra', 'harte-lampara-de-mesa-blanca', 'navlinge-lampara-con-gancho-para-mesa-blanca'], almacenaje: ['billy-oxberg-vidrio-madera-80cm', 'vittsjo-estante-doble-metal-y-vidrio', 'lack-vertical', 'billy-anexo-billy-grande', 'sunnersta-cubos-naranja'], cocina: ['ravunge-car-track-23', 'barndrom-duvet-twin-carritos-azul', 'upptag-pista-de-auto', 'nojaktig-plato-rattan', 'utvandig-bowl-dorado-32cm', 'arbete-bowl-deco-negro-1', 'arbete-bowl-deco-negro'], 'decoracion-essencia': ['malm-6-gavetas-vertical-con-espejo', 'underhalla-reloj-de-aprendizaje', 'sanglarka-mariposa-y-flores', 'vankrets-duvet-twin-cuadros-blanco-y-amarillo', 'grasvingel-duvet-twin-blanco-y-negro-con-flores', 'sanglarka-duvet-twin-flores', 'lappnycklar-duvet-full-queen', 'stilenlig-set-de-2-cuencos-flores-verde', 'omsesidig-jarra-vidrio', 'kaseberga-jarra-azul', 'stilenlig-tazas-set-de-2-flores-verdes', 'stilenlig-vasos-set-de-4-flores-verdes', 'stilenlig-set-de-platos-flores-verdes', 'vinterfint-set-de-vasos-corazon', 'sommarflox-bandeja-flores', 'alpklover-cojin-con-flores-blancas-20x20', 'saralena-cojin-negro-con-flor', 'sprangort-cojin-50x50cm', 'snoyra-luces-bolitas-40-led', 'strala-estrellitas-doradas-con-luces', 'strala-led-guirnalda-con-luz', 'copia-de-flaggspel-botella-con-luces', 'vissvass-40-luces-led', 'vinterfest-casita-luz', 'copia-de-vissvass-40-luces-led', 'strala-estrella-colgante-azul', 'strala-estrella-led', 'strala-arbolito-led', 'strala-casita-led', 'fallenhet-jarron-17cm', 'fallenhet-jarron-21cm', 'solig-canopy', 'skogskorn-tejido-de-colores-40x66cm', 'karismatisk-cojin-50x50cm-pink', 'karismatisk-cojin-58cm-flores', 'frodis-cojin-blanco-y-gris-blanco', 'spikklubba-cojin-50x50', 'silomal-cojin-50x50cm', 'anledning-cojin', 'skuggnava-cojin', 'ljungpipare-reloj-magnetico-verde', 'aromatisk-cojin-beige-con-flores-50x50', 'vinter-2021-bandeja-flores-verdes'] };
function finish() {
var pag = document.querySelector('.pagination'); if (pag) pag.style.display = 'none';
var cards = [].slice.call(out.querySelectorAll('.grid-product-container'));
var ban = BANISH[handle];
if (ban && ban.length) {
cards = cards.filter(function (c) {
var a = c.querySelector('a[href]'); var hh = a ? a.getAttribute('href') : '';
for (var bi = 0; bi < ban.length; bi++) { if (hh.indexOf('/products/' + ban[bi]) > -1) { if (c.parentNode) c.parentNode.removeChild(c); return false; } }
return true;
});
}
if (cards.length < 2) return;
var ord = ORDER[handle];
if (ord) {
cards.sort(function (a, b) { return orderPri(a, ord) - orderPri(b, ord); });
cards.forEach(function (c) { grid.appendChild(c); });
}
build(cards, out);
}
var p = 2, cap = 30;
function step() {
if (p > cap) return finish();
loadPage(p).then(function (has) { if (has) { p++; step(); } else finish(); });
}
step();
});
})();
